import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconTranchenmodellErdgas: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg version="1.1" id="Ebene_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
         viewBox="0 0 120.8 124.5" style={{ color }} xmlSpace="preserve" fill="currentColor">
    <path d="M61.1,124.5h-4v-13h4V124.5z M79.8,123.9L79.8,123.9c-0.6,0-1.2-0.3-1.5-0.7L39.4,76.5c-0.5-0.6-0.6-1.4-0.3-2.1
      c0.3-0.7,1-1.2,1.8-1.2h16.2V54.5c0-1.1,0.9-2,2-2h16.5L40.9,10.9L6.3,52.5h16.5c1.1,0,2,0.9,2,2v51.9h-4V56.5H2
      c-0.8,0-1.5-0.4-1.8-1.2c-0.3-0.7-0.2-1.5,0.3-2.1L39.4,6.5c0.4-0.5,0.9-0.7,1.5-0.7l0,0c0.6,0,1.2,0.3,1.5,0.7l38.9,46.7
      c0.5,0.6,0.6,1.4,0.3,2.1c-0.3,0.7-1,1.2-1.8,1.2H61.1v18.8c0,1.1-0.9,2-2,2H45.2l34.6,41.6l34.6-41.6H98c-1.1,0-2-0.9-2-2V18.2h4
      v55.1h18.8c0.8,0,1.5,0.4,1.8,1.2c0.3,0.7,0.2,1.5-0.3,2.1l-38.9,46.7C81,123.7,80.4,123.9,79.8,123.9z M37.7,119.3h-4V90.8h4V119.3
      z M87,33.7h-4V0h4V33.7z M63.7,18.1h-4v-13h4V18.1z"/>
          <path d="M76.1,95.6c-1.4-0.8-2.1-2.5-1.6-4c0.3-0.9,1-1.7,1.9-2.1c1.4-0.6,4.4-0.5,4.8,2.3c0.1,1.2-0.2,2.4-0.9,3.4
      c1.1-0.2,6.2-2.9,6.2-7.8c0-5.6-6-10.8-9-12.8c0.1,1.2-0.2,2.5-0.9,3.5c-1.8,3.2-5.5,5.3-6.5,8C68,91.8,76.1,95.5,76.1,95.6"/>
          <path d="M39,55.6c-1.4-0.8-2.1-2.5-1.6-4c0.3-0.9,1-1.7,1.9-2.1c1.4-0.6,4.4-0.5,4.8,2.3c0.1,1.2-0.2,2.4-0.9,3.4
      c1.1-0.2,6.3-2.9,6.3-7.8c0-5.5-6-10.8-9-12.8c0.1,1.2-0.2,2.5-0.9,3.5c-1.8,3.2-5.5,5.3-6.5,8C30.9,51.9,39,55.6,39,55.6"/>
    </svg>
  );
};
